/**
 * Auth State Interface
 *
 * This state manages authentication flow (login, logout).
 * User data is stored in the separate user state.
 */
export interface AuthState {
	// Loading state for async auth operations (login, logout)
	loading: boolean;

	// Error message from auth operations
	error: string | null;

	// Return URL for redirecting user after successful login
	// Set by AuthGuard when unauthenticated user tries to access protected route
	returnUrl: string | null;
}

export const initialAuthState: AuthState = {
	loading: false,
	error: null,
	returnUrl: null,
};
